import { _js } from '@ifixit/utils/localize';
import { FaIcon } from '@ifixit/ui/components/icon';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const ItalicButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('italic'),
      isDisabled: !editor.can().toggleItalic(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleItalic().run()}
         isActive={state.isActive}
         isDisabled={state.isDisabled}
         icon={<FaIcon name="italic" />}
         title={_js('Italic')}
         shortcut={'i'}
      />
   );
};
